// extracted by mini-css-extract-plugin
export default {"container":"I_8btlSC7jOe2x_rV3Ww","sendButtonIcon":"e9XkpnEe7wh7iERlNXsV","captions":"GUCUV2TbTcHe30I9YzMd","caption":"So90slGMUJEHwFy4t1Wp","subCaption":"wfc6qNdnb3lXt_xnbGrQ"};